<template>
  <div id="productos">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="LISTADO DE PRODUCTOS" color="primary darken-4" dark>
            <div slot="widget-content">
              <div>
                <v-btn
                  color="success"
                  dark
                  fab
                  small
                  slot="activator"
                  @click="abrirDialogNuevoProducto"
                >
                  <v-icon dark>add</v-icon>
                </v-btn>
                <form-producto
                  :producto="producto"
                  ref="dialogProducto"
                  @onProductoAdded="onProductoAdded"
                  @onProductoUpdated="onProductoUpdated"
                ></form-producto>
              </div>

              <v-layout row wrap>
                <v-flex lg12>
                  <v-card>
                    <v-toolbar card color="white">
                      <v-text-field
                        flat
                        solo
                        prepend-icon="search"
                        placeholder="Búsqueda rápida"
                        v-model="search"
                        hide-details
                        class="hidden-sm-and-down"
                      ></v-text-field>
                      <v-btn icon>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                      <v-data-table
                        :headers="headers"
                        :search="search"
                        :items="productos"
                        :rows-per-page-items="[
                          10,
                          25,
                          50,
                          { text: 'All', value: -1 },
                        ]"
                        class="elevation-1"
                        item-key="productoId"
                      >
                        <template slot="items" slot-scope="props">
                          <td>
                            <v-avatar size="48">
                              <v-icon color="primary" medium
                                >local_offer</v-icon
                              >
                            </v-avatar>
                          </td>
                          <td>{{ props.item.descripcion }}</td>
                          <td>{{ props.item.descripcionTipoProducto }}</td>
                          <td>{{ props.item.descripcionLineaProducto }}</td>
                          <td>{{ props.item.nombreMarca }}</td>
                          <td>{{ props.item.modelo }}</td>
                          <td>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="primary"
                              small
                              @click="getProducto(props.item.productoId)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="pink"
                              small
                              @click="deleteProducto(props.item.productoId)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                        <v-alert
                          slot="no-results"
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                        >
                          La búsqueda para "{{ search }}" no encontró registros
                        </v-alert>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import formProducto from "./FormProducto";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

import productoService from "@/services/productoService";

export default {
  components: {
    VWidget,
    confirm,
    loadingAlert,
    snackBar,
    formProducto,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "", align: "center", sortable: false },
        { text: "NOMBRE DEL PRODUCTO", align: "center", value: "descripcion" },
        { text: "TIPO", align: "center", value: "descripcionTipo" },
        { text: "LINEA", align: "center", value: "descripcionLinea" },
        { text: "MARCA", align: "center", value: "nombreMarca" },
        { text: "MODELO", align: "center", value: "modelo" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      productos: [],
      producto: {
        productoId: 0,
        descripcion: "",
        tipoProductoId: 0,
        lineaProductoId: 0,
        marcaId: 0,
        modelo: "",
      },
    };
  },
  mounted() {
    this.getProductos();
  },
  methods: {
    getProductos() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      productoService
        .getAll()
        .then((result) => {
          self.productos = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getProducto(productoId) {
      let self = this;

      self.$store.state.loadingInfo.show = true;
      productoService
        .get(productoId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR PRODUCTO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";
          self.$refs.dialogProducto.resetForm();
          self.producto = result;
          self.$refs.dialogProducto.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteProducto(productoId) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR PRODUCTO",
          "¿Estás seguro de eliminar el producto, se eliminará toda la información relacionada a éste?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            productoService
              .delete(productoId)
              .then(() => {
                var i = this.productos.findIndex(
                  (obj) => obj.productoId == productoId
                );
                self.productos.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text =
                  "Producto eliminado con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                self.operationFailed(e);
                console.log(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    onProductoAdded(producto) {
      this.productos.push(producto);
    },
    onProductoUpdated(producto) {
      var i = this.productos.findIndex(
        (obj) => obj.productoId == producto.productoId
      );
      this.productos.splice(i, 1, producto);
    },
    abrirDialogNuevoProducto() {
      this.$store.state.tituloForm = "AGREGAR PRODUCTO";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogProducto.resetForm();
      this.$refs.dialogProducto.openDialog();
    },
  },
};
</script>

<style>
thead tr th {
  background-color: #00202c;
  color: white !important;
  max-height: 15px;
}
thead tr th i {
  color: white !important;
}
</style>
